import React from 'react';
import { Button } from 'ui-toolkit/components/Button/Button';
import { Grid } from 'ui-toolkit/components/Grid';
import { BodyText } from 'ui-toolkit/components/Typography/basicTypography';

interface ISuccessMessageProps {
  successMessage: string | React.ReactNode;
  onOkClick?: () => void;
}

export const SuccessMessage: React.FC<ISuccessMessageProps> = ({ successMessage, onOkClick }) => (
  <Grid textAlign="center">
    <BodyText>{successMessage}</BodyText>
    {/* TODO: remove "type=reset". Using a button "type=reset" to close a modal is a bad pattern */}
    <Button intent={'primary'} type={'reset'} onClick={onOkClick}>
      OK
    </Button>
  </Grid>
);
